export default "__VITE_ASSET__Dv8jdEtv__"